import dayjs from 'dayjs';
import * as yup from 'yup';
import { slackLinkSchema } from '../components/form/schema-utils';
import {
  addOptionalNullableToSchema,
  addOptionalToSchema,
  emailSchema,
  phoneSchema,
  providerNPISchema,
  requiredErrorMessage,
  requiredNameSchema,
} from '@common/schema';

export const createProviderSchema = yup.object().shape({
  first_name: requiredNameSchema,
  last_name: requiredNameSchema,
  suffix: yup.string(),
  external: yup.boolean().required(requiredErrorMessage),
  npi: providerNPISchema.required(requiredErrorMessage),
  guide_certified: yup.boolean().required(requiredErrorMessage),
  guide_certification_date: yup
    .mixed<dayjs.Dayjs>()
    .required(requiredErrorMessage),
  partner_id: yup.string().required(requiredErrorMessage),
  practice_id: yup.string().required(requiredErrorMessage),
  email: addOptionalToSchema(emailSchema),
  phone_number: addOptionalToSchema(phoneSchema),
  region_id: addOptionalNullableToSchema(yup.string()),
  clinical_leader_id: addOptionalNullableToSchema(yup.string()),
  supervising_physician_id: addOptionalNullableToSchema(yup.string()),
  provider_specialty: yup.string().required(requiredErrorMessage),
  slack_link: slackLinkSchema,
});
